// extracted by mini-css-extract-plugin
export default {"inputBox":"Mvkxx5Z6BheOcAVpv_sZ","paymentDetailsBox":"UFBJQZjTIhecpU3MnGzk"};